'use client';

import { __rest } from '../_virtual/_tslib.js';
import React__default from 'react';
import { STContainer } from './styles.js';

var TagBasic = function (_a) {
    var props = __rest(_a, []);
    return (React__default.createElement(STContainer, { isActive: props.isActive, onClick: function () { return props.onClick(props.value); }, className: "".concat(props === null || props === void 0 ? void 0 : props.className, " ").concat(props.isActive ? 'active' : '') }, props.children));
};

export { TagBasic as default };
//# sourceMappingURL=index.js.map
